import React, { Component } from 'react'

class Footer extends Component {
  render() {
    return (
        <p className="app__footer">Drag and drop to reorder list</p>
    )
  }
}

export default Footer
